module.exports = __webpack_public_path__ + "img/top@2x.3eec999f.png";